
import { defineComponent, PropType } from "vue";
import { SlksDateFormat, useFormattedDate, SlksDate } from "@slks/core";

export default defineComponent({
    name: "FormattedDate",
    props: {
        date: {
            type: Object as PropType<SlksDate>,
            required: true,
        },
        format: {
            type: String as PropType<SlksDateFormat>,
            default: "default",
        },
        period: {
            type: Boolean,
            default: false,
        },
    },
    setup(props) {
        const { formattedDate } = useFormattedDate(props.date, props.format, props.period);

        return { formattedDate };
    },
});
